import { Component, Input } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'env-notice',
  templateUrl: 'env-notice.html'
})
export class EnvNoticeComponent {

  @Input() defaultPosition: boolean = true;

  public profile = {
    name: 'prod-spoke',
    label: '本番SPOKE',
  };

  public ngOnInit(): void {
    const url = `${location.hostname}/${location.href.split('/')[3]}`;
    const profile = environment.profiles.find((profile) => profile.url == url);

    if (profile) {
      this.profile = profile;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/env-notice/env-notice.ts